import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'swiper/dist/css/swiper.css'; // swiper的css
import "./assets/font/font.scss";
Vue.config.productionTip = false;
router.replace("/"); // 路由重定向，刷新页面回到首页


const vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
function isWeiXin() {
	var ua = window.navigator.userAgent.toLowerCase();
	if (ua.match(/MicroMessenger/i) == "micromessenger") {
		return true;
	} else {
		return false;
	}
}
function renderResize(){
	// 横屏
	let basesZoom = 0;
	let clientWidth = window.document.documentElement.clientWidth;
	let clientHeight = window.document.documentElement.clientHeight;
	if (clientWidth > clientHeight) {
		console.log("横屏状态下");
		basesZoom = 667 / 375; // 横屏状态下
	}else{
		console.log("竖屏状态下");
		basesZoom = 375 / 667; // 竖屏状态下
	}
	// if (window.orientation == 90 || window.orientation == -90) {
	// 	console.log("横屏状态下");
	// 	basesZoom = 667 / 375; // 横屏状态下
	// }else{
	// 	console.log("竖屏状态下");
	// 	basesZoom = 375 / 667; // 竖屏状态下
	// }
	let docEl = document.documentElement; // 获取 html 节点
	let transefromRemHandle = function(preWidth) {
		let fontEl = document.createElement("style");
		let base = 100;
		return function() {
			if (isWeiXin()) {
				clientHeight = clientHeight + 64;
			}
			let domStantd;
			if (clientWidth > clientHeight) {
				domStantd = clientWidth / clientHeight;
			}else{
				domStantd = clientWidth / clientHeight;
			}
			let zoom = basesZoom / domStantd;
			let rem;
			docEl.setAttribute("data-rem", rem);
			// if(zoom < 1){
			// 	fontEl.innerHTML = "html{font-size:" + rem + "px!important;}";
			// }else{
			// 	fontEl.innerHTML = "html{font-size:50px!important;}";
			// }
			if (clientWidth > clientHeight) {
				if(zoom < 1){
					rem = (clientHeight / 750) * base;
					fontEl.innerHTML = "html{font-size:" + rem + "px!important;}";
					docEl.setAttribute("data-rem", rem);
				}else{
					rem = (clientWidth / preWidth) * base;
					fontEl.innerHTML = "html{font-size:" + rem + "px!important;}";
					docEl.setAttribute("data-rem", rem);
				}
			}else{
				if(zoom > 1){
					rem = (clientWidth / preWidth) * base;
					fontEl.innerHTML = "html{font-size:" + rem + "px!important;}";
					docEl.setAttribute("data-rem", rem);
				}else{
					rem = (clientHeight / 1334) * base;
					fontEl.innerHTML = "html{font-size:" + rem + "px!important;}";
					docEl.setAttribute("data-rem", rem);
				}
			}
			// if(zoom > 1){
			// 	rem = (clientWidth / preWidth) * base;
			// 	fontEl.innerHTML = "html{font-size:" + rem + "px!important;}";
			// 	docEl.setAttribute("data-rem", rem);
			// }else{
			// 	rem = (clientHeight / 1334) * base;
			// 	fontEl.innerHTML = "html{font-size:" + rem + "px!important;}";
			// 	docEl.setAttribute("data-rem", rem);
			// }
			docEl.firstElementChild && docEl.firstElementChild.appendChild(fontEl);
		};
	};
	let num = 0;
	if (clientWidth > clientHeight) {
		num = 1334;
	}else{
		num = 750;
	}
	transefromRemHandle(num)();
	let windowResize = window.onresize;
	window.onresize = function(e) {
		windowResize != null && windowResize.bind(this);
		transefromRemHandle(num)();
	};
}
try{
	renderResize();
	window.addEventListener("resize",renderResize, false)
}catch(e){
	console.log(e);
}
